import {Component} from "react";
import Glob from "../../libs/Glob.mjs";
import "./LiveImage.css";
import TextLabel from "../../controls/TextLabel.mjs";

const lives = [
	{
		src : "live.jpg",
		local: true,
		alt: "Vista della valle dai Castiglioni"
	}
]

const LiveImage = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			root: window.glob.prop.uri.server+'/olistatic/',
			update: (new Date()).getTime()
		};
		this.uid = Glob.generateUid('LiveImage');
		this.startZoom = this.startZoom.bind(this);
		this.stopZoom = this.stopZoom.bind(this);
		this.stopTimeout = this.stopTimeout.bind(this);
	}
	componentDidMount() {
		Glob.register('EscapeKeyWasPressed', ()=>{
			if ( this.state.zoom ) this.stopZoom();
		}, this.uid);
	}
	componentWillUnmount() {
		Glob.unregister('EscapeKeyWasPressed', this.uid );
	}
	startZoom() {
		this.stopTimeout();
		let idx = (this.state.currentLiveIndex || 0) +1;
		if ( ! lives[idx] ) idx = 0;
		this.setState({
			zoom: true,
			currentLiveIndex: idx,
			currentLive: lives[idx],
			timeout: setTimeout( this.startZoom, 30000 ),
			update: (new Date()).getTime()
		})
	}
	stopZoom() {
		this.stopTimeout();
		this.setState({
			zoom: false,
			timeout: undefined,
			update: (new Date()).getTime()
		})
	}
	stopTimeout() {
		if ( ! this.state.timeout ) return;
		try { clearTimeout( this.state.timeout ); } catch(e) { }
		this.setState({ timeout: undefined });
	}
	render() {
		if ( this.state.zoom ) return (
			<div
				key={ this.state.update }
				onClick={  this.stopZoom }
				className={"LiveImage big"}
			>
				<div>
					<img
						src={ ( this.state.currentLive.local ? this.state.root : '' )+this.state.currentLive.src+'?update='+this.state.update }
						alt={ this.state.currentLive.alt }
						title={ this.state.currentLive.alt }
						onError={ this.startZoom }
					/>
					<div>
						{ this.state.currentLive.alt }
					</div>
				</div>
			</div>
		);
		return (
			<div
				onClick={ this.startZoom }
				className={"LiveImage small"}
			>
				<img src={this.state.root+"panorama.jpg"} alt={"Oliveto"}/>
				<span>
					<TextLabel value={"Click to live"} />
				</span>
			</div>
		)
	}
}

export default LiveImage;